var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tender.first_image)?_c('img',{staticStyle:{"object-fit":"cover"},attrs:{"height":"58","src":_vm.tender.first_image.conversions.feed,"width":"100"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }